<template>
  <div class="qir__wrapper">
    <qir-top-section
      :in-progress="inProgress"
      :report-data="reportData"
      :is-report-data-failed-to-load="isReportDataFailedToLoad"
    />

    <qir-overview />

    <qir-call-to-action />

    <qir-clients />

    <qir-faq />

    <qir-our-team />
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import QirTopSection from 'sections/_qir/QirTopSection/index.vue'
import QirOverview from 'sections/_qir/QirOverview/index.vue'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

async function getLatestQirData({ store }) {
  const { dispatch } = store

  return await dispatch('intelligence/requestLatestQuarterlyReport')
}

export default {
  name: 'QirPage',
  components: {
    QirClients: hydrateWhenVisible(() =>
      import('sections/_qir/QirClients/index.vue')
    ),
    QirCallToAction: hydrateWhenVisible(() =>
      import('sections/_qir/QirCallToAction/index.vue')
    ),
    QirFaq: hydrateWhenVisible(() => import('sections/_qir/QirFaq/index.vue')),
    QirOurTeam: hydrateWhenVisible(() =>
      import('sections/_qir/QirOurTeam/index.vue')
    ),
    QirOverview,
    QirTopSection
  },
  mixins: [mixins.initialScroll],
  head() {
    return this.$generateMetaTags({
      ogImageUrl: this.$helper.generateFmIntelligenceUrl(
        '/images/og-img-qir.png',
        this
      )
    })
  },
  async asyncData(ctx) {
    try {
      const reportData = await getLatestQirData({ store: ctx.store })

      return {
        reportData
      }
    } catch (err) {
      ctx.$errorHandler(err, this)

      return {
        reportData: null
      }
    }
  },
  data() {
    return {
      reportData: null,
      isReportDataFailedToLoad: false,
      inProgress: true
    }
  },
  methods: {
    async updateLatestQirData() {
      try {
        this.reportData = await getLatestQirData({ store: this.$store })
      } catch (err) {
        this.isReportDataFailedToLoad = true
        this.$errorHandler(err, this)
      } finally {
        this.inProgress = false
      }
    }
  },
  mounted() {
    this.updateLatestQirData()
  }
}
</script>

<style lang="scss" scoped></style>
